'use client';

import { useMutation } from '@tanstack/react-query';

import { signInWithEmailPassword } from '../server/email-password-sign-in.action';

interface SignInCredentials {
  email: string;
  password: string;
}

/**
 * Hook for email + password sign-in.
 *
 * Wraps the `signInWithEmailPassword` server action in a mutation. Every
 * failure throws the same 'Invalid login credentials' error; when the email
 * belongs to a user migrated from the Meteor app who has never set a password
 * here, the action also emails them a set-password link (BAL-1048).
 */
export function useEmailPasswordSignIn() {
  return useMutation({
    mutationFn: async (credentials: SignInCredentials) => {
      const result = await signInWithEmailPassword(
        credentials.email,
        credentials.password,
      );

      if (!result.success) {
        throw new Error(result.error || 'Sign in failed');
      }

      return result;
    },
  });
}
